import { Pipe, PipeTransform } from '@angular/core';
import { startCase, toLower } from 'lodash';

@Pipe({ name: 'cleanName' })
export class CleanNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    let result = value.replace(/^dm_/, '');
    result = result.replace(/_\d+$/, '');

    return startCase(toLower(result));
  }
}
